@if (address) {
  <div
    [innerHtml]="adaptAddress(address) | address : false : true">
  </div>
}